import React, { useState } from "react";
import { MonitorSmartphone } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, formatApiErrorDetail } from "@/lib/api";

export const DeviceSelfReset = ({ email, password, onDone }) => {
  const [sent, setSent] = useState(false);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const call = async (path, body, ok) => {
    setBusy(true); setErr("");
    try { await api.post(path, body); ok(); }
    catch (e) { setErr(formatApiErrorDetail(e.response?.data?.detail)); }
    setBusy(false);
  };
  const request = () => call("/auth/devices/self-reset/request", { email, password }, () => { setSent(true); toast.success("Code sent — check your email"); });
  const confirm = () => call("/auth/devices/self-reset/confirm", { email, password, code }, () => { toast.success("All other devices signed out"); onDone(); });
  return (
    <div className="rounded-2xl border border-border bg-secondary p-4 text-sm" data-testid="device-self-reset">
      <p className="flex items-center gap-2 font-medium text-foreground"><MonitorSmartphone size={16} className="text-primary" /> Lost a device or changed phone?</p>
      <p className="mt-1 text-xs text-muted-foreground">We'll email you a code to sign out all your devices so you can sign in here. You can do this once every 30 days.</p>
      {!sent ? (
        <Button type="button" size="sm" disabled={busy} onClick={request} className="mt-3 rounded-full" data-testid="device-reset-request">Email me a code</Button>
      ) : (
        <div className="mt-3 flex gap-2">
          <Input value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))} inputMode="numeric" placeholder="6-digit code" className="bg-background" data-testid="device-reset-code" />
          <Button type="button" size="sm" disabled={busy || code.length !== 6} onClick={confirm} className="rounded-full" data-testid="device-reset-confirm">Sign out devices</Button>
        </div>
      )}
      {err && <p className="mt-2 text-xs text-red-600 dark:text-red-400" data-testid="device-reset-error">{err}</p>}
    </div>
  );
};
